// extracted by mini-css-extract-plugin
export default {"container":"TermOfUse_container__jjkQ-","spinnerWrapper":"TermOfUse_spinnerWrapper__+Hpf7"};